import { api } from '@/core/api/';

const baseUrl = '/api/userRequest';

export const getFiscalYears = async () => {
  try {
    const { data } = await api.get(`${baseUrl}/fiscalyears`);
    return data;
  } catch (error) {
    return error;
  }
};

export const getStatuses = async () => {
  try {
    const { data } = await api.get(`${baseUrl}/statuses`);
    return data;
  } catch (error) {
    return error;
  }
};

export const getUserRequests = async (filters) => {
  try {
    const { data } = await api.get(`${baseUrl}/requests`, {
      params: { ...filters },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getGeneralAccountData = async (filters) => {
   return await api.get(`${baseUrl}/generalaccountdata`, {
      params: { ...filters },
    });
};

export const submitUserRequest = (params) =>
  api.post(`${baseUrl}/submit`, params);

export const getRequestAccountUser = (requestId) =>
  api.get(`${baseUrl}/request/${requestId}`);

export const changeRequestStatus = async (dto) => {
  try {
    const { data } = await api.put(`${baseUrl}/changestatus`, dto);
    return data;
  } catch (error) {
    return error;
  }
};

export const getHistory = async (filters) => {
  try {
    const { data } = await api.get(`${baseUrl}/history`, {
      params: { ...filters },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getUserCompanies = async () => {
  try {
    const { data } = await api.get(`${baseUrl}/loginusercompanies`);
    return data;
  } catch (error) {
    return error;
  }
};
